import ResetPassModal from './ResetPassContainer';

export default ResetPassModal;
